import styled, { css } from "styled-components";

import fonts from "core/fonts";
import colors from "core/colors";
import { easingSeconds } from "core/animation";
import breakpoints from "core/breakpoints";
import { convertPxToRem } from "frontend/components/helpers";

// components
import CaretDown from "../ReusableIcons/CaretDown";

export const CaretDownStyled = styled(CaretDown)``;

export const MoreButton = styled.button`
    cursor: pointer;
    background: ${colors.primary.snow};
    overflow: hidden;
    display: inline-flex;
    align-items: center;

    font-size: ${convertPxToRem(15)};
    color: ${colors.secondary.basalt};
    text-decoration: none;

    border: ${convertPxToRem(1)} solid ${colors.primary.scheifer};
    padding: ${convertPxToRem(6)} ${convertPxToRem(8)};
    margin: 0;

    ${CaretDownStyled} {
        margin-left: ${convertPxToRem(8)};
        path {
            fill: ${colors.secondary.basalt};
        }
    }

    ${({ open }) => {
        if (open) {
            return css`
                ${CaretDownStyled} {
                    transform: rotate(180deg);
                }
            `;
        }
    }}

    transition: all ${easingSeconds};

    &:hover,
    &:focus {
        border-color: transparent;
        background: ${colors.primary.moon};
        color: ${colors.secondary.cosmic};
        ${CaretDownStyled} {
            path {
                fill: ${colors.secondary.cosmic};
            }
        }
    }

    /* mobile-only: */
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        margin-top: 1.5rem; /* 24px */
    }

    /* tablet + desktop: */
    @media (min-width: ${breakpoints.tablet.rem}) {
        margin-bottom: 1.5rem; /* 24px */
    }
`;
